import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RelayModel } from '@rift/models/restapi/Relay.Model';
import { ResultModel } from '@rift/models/restapi/Result.Model';
import { ConnectionTokenService } from '@rift/service/connection/ConnectionToken.Service';
import { RiftRestApiService } from '@rift/service/restapi/base/RiftRestApi.Service';
import { ConfigurationService } from '@shared/service/configuration/Configuration.Service';
import { ProcessMonitorServiceProcess } from '@shared/service/processmonitor/ProcessMonitor.Service.Process';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class RestApiRelaysService extends RiftRestApiService {
    private _controller = 'relays';

    public constructor(
        private readonly _dialog: MatDialog,
        private readonly _connectionTokenService: ConnectionTokenService,
        private readonly _config: ConfigurationService,
        private readonly _httpClient: HttpClient) {
        super(_dialog, _config.riftV1RestApiBase, _httpClient, _connectionTokenService);
    }

    public getSettings(process?: ProcessMonitorServiceProcess): Observable<RelayModel> {
        return this.get<RelayModel>(`${this._controller}/settings`, RelayModel, this.getTokenParams(), process).pipe(
            map(result => this.handleErrorOrThrow(result))
        );
    }

    public setSettings(settings: RelayModel, process?: ProcessMonitorServiceProcess): Observable<ResultModel> {
        return this.put<RelayModel, ResultModel>(`${this._controller}/settings`, settings, ResultModel, this.getTokenParams(), process).pipe(
            map(result => this.handleErrorOrThrow(result))
        );
    }
}
